import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export const DROPDOWN_COORDINATOR_IDS = {
  profileMenu: 'profile-menu',
  notificationDropdown: 'notification-dropdown',
  downloadReport: 'download-report',
} as const;

@Injectable({ providedIn: 'root' })
export class DropdownCoordinatorService {
  private readonly opened$ = new Subject<string>();

  readonly onOpened$ = this.opened$.asObservable();

  notifyOpened(sourceId: string): void {
    this.opened$.next(sourceId);
  }
}
